/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CreateDirectiveRequest = zod
	.object({
		description: zod.string().nullish().describe('Directive description'),
		key: zod.string().describe('Unique key for the directive'),
		name: zod.string().describe('Directive name')
	})
	.describe('Request body for creating a directive');

export type CreateDirectiveRequest = zod.input<typeof CreateDirectiveRequest>;
export type CreateDirectiveRequestOutput = zod.output<typeof CreateDirectiveRequest>;
